import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getPrintClient } from "src/services/client";
import { PrintClient } from "src/types";
import EquivalentYieldCalculator from "src/components/Calculators/EquivalentYieldCalculator";
import PrintReady from "src/components/PrintReady";

const EquivalentYieldPrintPage = () => {
  const [client, setClient] = useState<PrintClient>({} as any);
  const { id } = useParams();

  useEffect(() => {
    if (id)
      getPrintClient(id).then((data) => {
        setClient(data);
      });
  }, [id]);

  if (!client.id) return <div>Loading...</div>;

  const calc = client.equivalentYieldCalculator || {};

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">
        Equivalent Yield (Life Insurance)
      </h1>
      <EquivalentYieldCalculator calc={calc} />
      <PrintReady />
    </div>
  );
};

export default EquivalentYieldPrintPage;
